import { View, Text } from "react-native"
import styles from "./ChampModal.styles"
import { ReactNode } from "react"

interface ChampModalProps {
  title: string,
  content: ReactNode
}

const ChampModal = ({title, content}: ChampModalProps) => (
  <View style={styles.row}>
    <Text style={styles.label}>{title}</Text>
    <Text style={styles.value}>{content}</Text>
  </View>
)

export default ChampModal